export const INVOKE_DELEGATE_HTTP = 'InteractionInterface.v1_0.InvokeDelegateHttpSkillMethod';
